import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { db } from '../lib/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';

export const MessagesBadge = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [totalUnread, setTotalUnread] = useState(0);

  useEffect(() => {
    if (!user) {
      setTotalUnread(0);
      return;
    }

    const q = query(
      collection(db, 'conversations'),
      where('participants', 'array-contains', user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let count = 0;
      snapshot.docs.forEach(doc => {
        const data = doc.data();
        const userUnread = data.unreadCounts?.[user.uid] || 0;
        count += userUnread;
      });
      setTotalUnread(count);

      // Note: We could trigger real browser notifications here or app-level notifications
      // if we detect that count > previousCount
    }, (error) => {
      console.error("Error fetching unread messages:", error);
    });

    return () => unsubscribe();
  }, [user]);

  return (
    <button 
      onClick={() => navigate('/messages')}
      className="hidden md:flex relative p-2 rounded-full hover:bg-white/10 transition-colors text-gray-400 hover:text-white items-center justify-center"
      title="Messages"
    >
      <MessageSquare className="w-5 h-5" />
      {totalUnread > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-[#FF5C00] text-white text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-[#0A0A0A]">
          {totalUnread > 99 ? '99+' : totalUnread}
        </span>
      )}
    </button>
  );
};
